module.exports = __webpack_public_path__ + "img/journey-blue-logo.272d04f9.svg";